/*
 * Copyright (c) 2026 Talent Catalog.
 *
 * This program is free software: you can redistribute it and/or modify it under
 * the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 3 of the License, or any later version.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License
 * for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program. If not, see https://www.gnu.org/licenses/.
 */

import {Component, OnInit} from '@angular/core';
import {CreateChatRequest, JobChat} from "../../../model/chat";
import {ChatService} from "../../../services/chat.service";

@Component({
  selector: 'app-manage-chats',
  templateUrl: './manage-chats.component.html',
  styleUrls: ['./manage-chats.component.scss']
})
export class ManageChatsComponent implements OnInit {
  chats: JobChat[] = [];

  error: any;
  loading: boolean;

  private selectedChat: JobChat;

  constructor(private chatService: ChatService) { }

  ngOnInit(): void {
    this.loading = false;
    this.error = null;
    this.chatService.list().subscribe(
        chats => {
          this.chats = chats;
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }

  doEditChat() {
    //Not supported yet
  }

  doNewChat() {
    let request: CreateChatRequest = {};
    this.loading = false;
    this.error = null;
    this.chatService.create(request).subscribe(
        jobChat => {
          this.chats.push(jobChat);
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }

  onChatSelected(selectedChat: JobChat) {
      this.selectedChat = selectedChat;
  }
}
